import { ElementPresetData } from '../presets';
import { ElementType } from '../element';
import { OPENS } from './opens';

class OpensManager {

    public addOpens(elements: ElementPresetData[]) {
        elements
            .filter((element) => element.type === ElementType.FRONT)
            .forEach((front: any) => {
                const hinge = elements.find((element) =>
                    element.type === ElementType.HINGE &&
                    element.position.x === front.position.x &&
                    element.position.y === front.position.y);
                if (!hinge) {
                    front.opens = OPENS.FORWARD;
                } else if (hinge.model.includes('L')) {
                    front.opens = OPENS.LEFT;
                } else { front.opens = OPENS.RIGHT; }
            });
    }
}

export const opensManager = new OpensManager();
